module.exports = __webpack_public_path__ + "img/currencyDetails2.aba3ec11.png";